import React from 'react'
import moment from 'moment'
import FormattedPhoneNumber from 'transfix-ui/components/FormattedPhoneNumber'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import { IMotorCarrierInsuranceContact } from 'types/FMSGraphqlTypes'
import FORMATS from 'constants/datetime'

interface IContact {
  contact: IMotorCarrierInsuranceContact
}

const InsuranceContactInformationRow = ({ contact }: IContact) => {
  const { createdAt, email, fullName, organizationName, phoneNumber } = contact
  return (
    <div>
      <Typography variant='subtitle1'>{organizationName} Insurance</Typography>
      <Box display='grid' gridTemplateColumns='1fr 1fr'>
        <div>
          <Typography variant='body2'>{fullName}</Typography>
          <Typography variant='body2'>{email}</Typography>
          <Typography variant='body1'>
            <FormattedPhoneNumber phoneNumber={phoneNumber} />
          </Typography>
        </div>
        <Box textAlign='end'>
          <Typography variant='body2'>
            Date Submitted: {moment(createdAt).format(FORMATS.dateFormat)}
          </Typography>
        </Box>
      </Box>
    </div>
  )
}

export default InsuranceContactInformationRow
